module.exports = __webpack_public_path__ + "img/forecast_probit.cfaeec20.png";